import React from "react"
import fabStyles from "./fab.module.scss"
import Wpp from "../assets/img/whatsapp_green.svg"

export default function Fab() {
  return (
    <div className={fabStyles.fab}>
      <a
        href="https://api.whatsapp.com/send?phone=573233450926&text=Hola,%20quiero%20pedir%20un%20domicilio."
        rel="noopener noreferrer"
        target="_blank"
      >
        <img src={Wpp} alt="Whatsapp" />
      </a>
    </div>
  )
}
